export default "__VITE_PUBLIC_ASSET__e480ac18__"